import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { RootState } from 'store/reducers';
import { updateTutorial } from 'store/actions/userActions';

import { Col, Row } from 'modules/bootstrap/components';
import { ContactUsForm, Faq } from 'modules/contactUs/components';
import { Button } from 'modules/common/components';

import facebook from 'images/facebook.svg';
import instagram from 'images/instagram.svg';

function ContactUs() {
  const { t } = useTranslation(['auth', 'common', 'contacts']);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state: RootState) => state.user.current);

  const [redirecting, setRedirecting] = React.useState(false);

  const startTutorial = async () => {
    setRedirecting(true);
    await dispatch(
      updateTutorial({ ...(user?.tutorial || {}), dashboard: true })
    );
    navigate('/dashboard');
  };

  return (
    <>
      <Row className="t-h-100">
        <Col xl={{ span: 6, offset: 2 }}>
          <div className="t-bg-beta-50 t-rounded t-shadow-lg md:t-p-12 xs:t-px-8 xs:t-py-10 t-mb-7">
            <div className="Contacts">
              <h1 className="Typography Typography--title u-weight-600 u-pb-10">
                {t('contacts:title')}
              </h1>
              <p className="Typography Typography--subTitle u-pb-40">
                {t('contacts:description')}
              </p>
              <div className="card t-pt-7 t-px-7 t-pb-5">
                <ContactUsForm />
              </div>
            </div>
            <Faq />
          </div>
        </Col>
        <Col xl={{ span: 4 }} className="sm:t-py-0">
          <div className="card md:t-p-12 xs:t-px-8 xs:t-py-10 t-mb-5">
            <h2 className="Typography Typography--title u-weight-600 u-pb-10">
              {t('contacts:touch_title')}
            </h2>
            <p className="Typography Typography--subTitle u-pb-40">
              {t('contacts:touch_description')}
            </p>
            <a
              href={`mailto:${t('contacts:client_email_mail_to')}`}
              className="Typography Typography--subTitle u-weight-600 u-noUnderline u-color-jelly-bean"
            >
              {t('contacts:client_email')}
            </a>
            <p className="Typography Typography--subTitle u-weight-600 u-pt-20">
              {t('contacts:client_tel')}
            </p>
            <p className="Typography Typography--subTitle u-weight-600 u-pt-20">
              {t('contacts:client_adr1')}
            </p>
            <p className="Typography Typography--subTitle u-weight-600">
              {t('contacts:client_adr2')}
            </p>
            <p className="Typography Typography--subTitle u-weight-600 u-pb-30">
              {t('contacts:client_adr3')}
            </p>
            <ul className="d-flex">
              <li className="u-mr-20">
                <a
                  href={t('contacts:client_facebook')}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="u-noUnderline"
                >
                  <img src={facebook} className="d-block" alt="facebook" />
                </a>
              </li>
              <li className="u-mr-20">
                <a
                  href={t('contacts:client_instagram')}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="u-noUnderline"
                >
                  <img src={instagram} className="d-block" alt="instagram" />
                </a>
              </li>
            </ul>
          </div>
          {user?.regular && (
            <div className="card md:t-p-12 xs:t-px-8 xs:t-py-10 t-mb-7 t-hidden xl:t-inline-block">
              <h1 className="typo-alpha">
                {t('contacts:dashboard_tour_widget_title')}
              </h1>
              <p className="typo-gamma t-mt-3">
                {t('contacts:dashboard_tour_widget_description')}
              </p>
              <Button
                category="secondary"
                className="t-mt-3"
                onClick={startTutorial}
                loading={redirecting}
              >
                {t('contacts:dashboard_tour_widget_button')}
              </Button>
            </div>
          )}
        </Col>
      </Row>
    </>
  );
}

export default ContactUs;
